import { render, staticRenderFns } from "./BrSubmitSteps.vue?vue&type=template&id=e06fda5e&"
import script from "./BrSubmitSteps.vue?vue&type=script&lang=js&"
export * from "./BrSubmitSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports